// The cover over the board while a match is set up. When the caster select
// opens, the cover closes over the board in rings, from the edge in, and the
// select shows when it is closed. When the select closes, the cover opens from
// the middle out. Garrett, 2026-10-14: "maybe 'close up the board' somehow
// magically in same animated aesthetic as our die".
// The match waits while the cover is not open: the director starts no beat and
// the AI does not act. So a match that the player leaves for the select does
// not play on behind it, and a new match has its opening beats after the board
// is open. With reduced motion the cover closes and opens at once.

import { BOARD_COVER_MS, REDUCED_MOTION_QUERY } from '../constants';
import { createStore } from '../lib/store';
import { isSettingUp, subscribeSetup } from './setup';

export type BoardCover = 'open' | 'closing' | 'closed' | 'opening';

export const boardCoverStore = createStore<BoardCover>('open');

export const isBoardOpen = (): boolean => boardCoverStore.get() === 'open';

let timer: number | undefined;

const settleAfter = (next: BoardCover, ms: number): void => {
  window.clearTimeout(timer);
  if (ms <= 0) {
    boardCoverStore.set(next);
    return;
  }
  timer = window.setTimeout(() => boardCoverStore.set(next), ms);
};

const follow = (): void => {
  const cover = boardCoverStore.get();
  const instant = window.matchMedia(REDUCED_MOTION_QUERY).matches;
  if (isSettingUp() && (cover === 'open' || cover === 'opening')) {
    boardCoverStore.set('closing');
    settleAfter('closed', instant ? 0 : BOARD_COVER_MS);
  } else if (!isSettingUp() && (cover === 'closed' || cover === 'closing')) {
    boardCoverStore.set('opening');
    settleAfter('open', instant ? 0 : BOARD_COVER_MS);
  }
};

/**
 * Call once at startup. A page that opens on the select starts with the cover
 * closed and no motion.
 */
export const startBoardCover = (): void => {
  if (isSettingUp()) boardCoverStore.set('closed');
  subscribeSetup(follow);
};
